import React from "react";
import { Modal } from "@/components";
import { ModalTexts } from "@/resources/locale";
import { RegisterForm } from "../../Forms";
import { RegisterLinks } from "../RegisterLinks";
import { useModalNavigation } from "../../hooks/useModalNavigation";
import { RulesAndPolicyText } from "@/components/RulesAndPolicyText";

interface RegistrationModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

export const RegistrationModal: React.FC<RegistrationModalProps> = ({
  isOpen,
  setIsOpen,
  onClose,
}) => {
  const { handleCode, handleAuth } = useModalNavigation();

  return (
    <Modal
      title={ModalTexts.register.regStart.TITLE}
      subTitle={ModalTexts.register.regStart.SUB_TITLE}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeModal={onClose}
      mobileContentSize="full-screen-page-header"
    >
      <RegisterForm handleSubmitForm={handleCode} />

      <RulesAndPolicyText />

      <RegisterLinks text="Есть аккаунт?" linkText="Войти" onLinkClick={handleAuth} />
    </Modal>
  );
};

